
import { useNavigate } from 'react-router-dom';

export const useCalculatorNavigation = () => {
  const navigate = useNavigate();

  const handleNavigateToBuyingPower = () => {
    if (import.meta.env.MODE === "development") {
      console.log("Button triggered: Navigate to Buying Power");
    }
    navigate('/buying-power');
  };

  const handleNavigateToAnalysis = () => {
    if (import.meta.env.MODE === "development") {
      console.log("Button triggered: Navigate to Analytics");
    }
    navigate('/analytics');
  };

  const handleNavigateToCalculator = () => {
    if (import.meta.env.MODE === "development") {
      console.log("Button triggered: Navigate to Calculator");
    }
    navigate('/calculator');
  };

  return {
    handleNavigateToBuyingPower,
    handleNavigateToAnalysis,
    handleNavigateToCalculator
  };
};
